// B-new-2656 / B-new-2642 (option A, one-step design): the first-layer notice
// a candidate sees next to the apply button before Xeito sends their name,
// email and profile job title to the employer that posted a vacancy (legal
// basis GDPR Art. 6(1)(b); this is a notice, not a consent). Memo:
// eu-spain-saas-lawyer MODE R 2026-10-16, "FOLLOW-UP: one-step design".
//
// Read by BOTH apps: `apps/api/src/routers/jobs.ts` (`applyToEmployerJob`
// binds its input to the version and records the template as the receipt in
// `consent_log`) and the web `EmployerApplyButton`.
//
// BUMP EMPLOYER_APPLY_NOTICE_VERSION whenever the button label, sub-label or
// privacy-link text changes (any locale), and keep the template below in step
// with `jobs.employerApply.{button,subLabel,privacyLink}` in apps/web en.json.
export const EMPLOYER_APPLY_NOTICE_VERSION = '2026-10-16.2';

/** `consent_log.consent_type` of the receipt row. */
export const EMPLOYER_APPLY_NOTICE_CONSENT_TYPE = 'employer_application_notice';

/**
 * EN source of the notice TEMPLATE exactly as rendered (button label,
 * sub-label, privacy-link text and href), as a JSON string, with `{{company}}`,
 * `{{marketingUrl}}` and `{{locale}}` deliberately left UNRESOLVED (the href has
 * the same shape the web component renders, `employerApplyPrivacyHref`; the
 * receipt's `source` stores the locale): a receipt that named the employer
 * would outlive an application withdrawal (memo Q4). Stored in
 * `consent_log.consent_text`.
 *
 * The privacyHref placeholder form replaced a hard-coded `/en/...` path WITHOUT
 * a version bump: nothing has been published under '2026-10-16.2' yet, so no
 * receipt exists with the old text. Any change after the first publish MUST
 * bump EMPLOYER_APPLY_NOTICE_VERSION.
 */
export const EMPLOYER_APPLY_NOTICE_TEMPLATE = JSON.stringify({
  button: 'Apply with your Xeito profile',
  subLabel: 'Sends your name, email and job title to {{company}}.',
  privacyLink: 'How your data is shared',
  privacyHref: '{{marketingUrl}}/{{locale}}/privacy-policy/#employmentIntermediation',
});
